import React, { useEffect, useState } from 'react';

import './loginCustom.css';
import styles from './PxbLifeAppLogin.styles';
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { pxbLifeAppActions } from "../state/PxbLifeAppSlice";
import {Backdrop, CircularProgress, Container} from '@mui/material';
import {LoginCustom} from './logincustom';
import Footer from "../Footer/Footer";
import Body from "../Body-content/Body";
import Headercontent from '../Header-content/HeaderContent';


function PxbLifeAppLogin() {

    const dispatch = useDispatch();
    const location = useLocation();

    // Parse the query params and update
    useEffect(() => {

        const queryParams: any = new URLSearchParams(location.search);
        const appParams: any = {};
        for (let [key, value] of queryParams.entries()) {
            appParams[key] = value;
        }

        const updateAppConfig = async () => {
            await dispatch(pxbLifeAppActions.updateAppConfig({
                ou: appParams['ou'],
                clientId: appParams['client_id'],
                goto: appParams['goto']
            }));
        }

        updateAppConfig();

    }, [location, dispatch])

    // page loading
    const [isPageLoading, setPageLoading] = useState(false);

    return (
        <Container maxWidth={false} style={{padding: 0}} sx={{...styles.container}} className='page-container'>

            <Backdrop
                sx={{color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1}}
                open={isPageLoading}
            >
                <CircularProgress color="inherit"/>
            </Backdrop>

            <Headercontent />
            <LoginCustom />

            <Body />
            <Footer />


        </Container>
    );
}

export default PxbLifeAppLogin;